// @flow
declare var Mazemap: any;

require("./route-info-box.scss");
// $FlowFixMe
import assign from 'object.assign';
import { $$ } from "utils/FakeQuery";
import { Events } from "utils/Events";

type State = {
    route?: ?Object,
    avoidStairs?: boolean,
};

export class RouteInfoBox{
    events: Events;
    state: State;
    $container: Object;
    onAvoidStairsChange: (state: bool)=>void;
    $avoidStairsCheckboxContainer: Object;

    constructor(onAvoidStairsChange: (state: bool)=>void ){
        this.state = {
            route: null,
            avoidStairs: false,
        }
        this.onAvoidStairsChange = onAvoidStairsChange;

        this.events = new Events();

        this.$container = $$('<div class="mm-ui route-info-box"></div>');
        this.$avoidStairsCheckboxContainer = $$(`
            <div class="avoidstairs-container">
                <input style="position:relative;" class="card-checkoption avoidstairs" type="checkbox" name="avoidStairsToggle" id="avoidStairsToggle" ${ this.state.avoidStairs ? 'checked="true"' : '' }>
                <label for="avoidStairsToggle">
                    Avoid stairs and obstacles
                </label>
            </div>
        `);

        this.$avoidStairsCheckboxContainer.find('input').on('change', (e) => {
            var checked = e.target.checked;
            this.setState({avoidStairs: checked});
            this.onAvoidStairsChange && this.onAvoidStairsChange(checked);
        });
    }

    setState(state: State){
        this.state = assign({}, this.state, state);
        this.render();
    }

    render (){
        this.$container.empty();
        var route = this.state.route;

        if( route ){
            var pathMetrics = route.properties.pathMetrics;
            if( pathMetrics.distanceWalkingMeters ){
                var meters = Mazemap.Util.metersToString( pathMetrics.distanceWalkingMeters );
                this.$container.append( $$('<div class="estimate-item">'+ meters +'</div>') );
            }

            var minutes = Mazemap.Util.minutesToString( pathMetrics.durationWalkingMinutes);
            this.$container.append( $$('<div class="estimate-item">'+ minutes +'</div>') );

            this.$container.append( this.$avoidStairsCheckboxContainer );


            this.$container.show();
        }else{
            this.$container.hide();
        }

        return this.$container.get(0);
    }
}


// WEBPACK FOOTER //
// src/kiosk/RouteInfoBox/index.js